import { FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';

export function SampleInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Strategy</FieldLabel>
      <Segmented value={c.mode || 'random'} onChange={(v) => u({ mode: v })}
        options={[
          { value: 'random', label: 'Random' },
          { value: 'stratified', label: 'Stratified' },
          { value: 'systematic', label: 'Systematic' },
        ]} />
      <FieldLabel>Size</FieldLabel>
      <Segmented value={c.unit || 'n'} onChange={(v) => u({ unit: v })}
        options={[
          { value: 'n', label: 'Rows' },
          { value: 'pct', label: 'Percent' },
        ]} />
      {(c.unit || 'n') === 'pct'
        ? <TextInput mono type="number" value={c.pct ?? 10} onChange={(v) => u({ pct: Number(v) })} />
        : <TextInput mono type="number" value={c.n ?? 1000} onChange={(v) => u({ n: Number(v) })} />}
      <FieldLabel>Random seed</FieldLabel>
      <TextInput mono value={c.seed ?? '42'} onChange={(v) => u({ seed: v })} />
    </div>
  );
}
